import React from "react";

const BuiltOnAWS = () => {
  const partnerLogos = [
    {
      id: 1,
      img: "/images/partner-logos/aws.svg",
      alt: "AWS",
      size: "w-20 h-7 md:w-24 md:h-7 lg:w-32 lg:h-7",
    },
    {
      id: 2,
      img: "/images/partner-logos/snowflake.svg",
      alt: "Snowflake",
      size: "w-20 h-8 md:w-24 md:h-10 lg:w-32 lg:h-10",
    },
    {
      id: 3,
      img: "/images/partner-logos/databricks.svg",
      alt: "Databricks",
      size: "w-20 h-8 md:w-24 md:h-10 lg:w-32 lg:h-10",
    },
    {
      id: 4,
      img: "/images/partner-logos/adobe.svg",
      alt: "Adobe",
      size: "w-20 h-6 md:w-24 md:h-6 lg:w-32 lg:h-6",
    },
    {
      id: 5,
      img: "/images/partner-logos/amdoc.svg",
      alt: "Amdocs",
      size: "w-20 h-6 md:w-24 md:h-6 lg:w-32 lg:h-6",
    },
    {
      id: 6,
      img: "/images/partner-logos/dbt.svg",
      alt: "dbt",
      size: "w-20 h-7 md:w-24 md:h-7 lg:w-32 lg:h-7",
    },
  ];

  return (
    <div className="w-full bg-gray-100 py-16 lg:py-14">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] md:text-[40px] lg:text-[48px] xl:text-[56px] text-[#0A1931] RoobertLight leading-[120%] mb-4">
            Built on AWS. Deployed in your environment.
          </h2>
          <h3 className="text-[20px] md:text-[22px] lg:text-[24px] xl:text-[28px] text-[#0A1931] RoobertMedium leading-[120%]">
            No black box. No hidden lock-in.
          </h3>
        </div>

        {/* Main Content Area */}
        <div className="bg-white p-6 md:p-8 lg:p-12 rounded-lg shadow-lg relative">
          {/* Green L-shaped lines */}
          <div className="absolute top-0 right-0 w-24 md:w-28 lg:w-32 h-24 md:h-28 lg:h-32 border-t-2 border-r-2 border-[#66FF00]"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-x-24">
            {/* Content */}
            <div className="space-y-6">
              <p className="text-[16px] md:text-[17px] lg:text-[18px] text-black RoobertRegular leading-[140%]">
                We work exclusively on AWS - our GenAI Studio, delivery
                platform, and reusable agent libraries are built from the ground
                up for AWS-native environments.
              </p>
              <p className="text-[16px] md:text-[17px] lg:text-[18px] text-black RoobertRegular leading-[140%]">
                Every deployment runs securely in your cloud - with your data,
                your controls, and your team in the loop.
              </p>
            </div>

            {/* Partner Logos */}
            <div className="grid grid-cols-2 gap-4 md:gap-6 gap-x-0 justify-center items-center">
              {partnerLogos.map((logo) => {
                return (
                  <img src={logo.img} alt={logo.alt} className={logo.size} />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuiltOnAWS;
